import FileDownload from 'js-file-download'
import * as apisPortal from '/@src/client-portal/api'
import * as apisIs from '/@src/client-is/api'

const zoppmDraftApi = new apisPortal.ZoppmDraftApi()
const portalZoppmApi = new apisPortal.PortalZoppmApi()
const portalZiadostiApiIs = new apisIs.PortalZiadostiApi()

type UsePrilohaDownloadParamsType = {
  stavPodana?: boolean
  ziadostId?: string
  bearerTokenIS?: string
  kodIrz?: string
}

/**
 * Hook vráti funkciu na stiahnutie prílohy zhrnutia.
 * Rozlišuje, ktorý endpoint má byť prevolaný, podľa toho kde zhrnutie práve zobrazujeme:
 * 1. zhrnutie - žiadosť rozpracovaná
 * 2. zhrnutie - žiadosť podaná
 * 3. zhrnutie - IS iframe
 * Vo každom z prípadov je nutné volať iný endpoint.
 * @param stavPodana Príznak či sa jedná o podanú výzvu.
 * @param ziadostId Id žiadosti -
 * @param bearerTokenIS
 * @param kodIrz
 */
export const usePrilohaDownload = ({
  stavPodana,
  ziadostId,
  bearerTokenIS,
  kodIrz,
}: UsePrilohaDownloadParamsType) => {
  const getDokument = async (identifikatorUlozisko: string, verziaUlozisko: string) => {
    if (stavPodana) {
      if (!ziadostId) {
        return
      }
      if (bearerTokenIS) {
        console.log('Downloading priloha from IS', bearerTokenIS)
        await portalZiadostiApiIs
          .fetchContentOfDokumentForZoppmPortalZiadosti(
            ziadostId,
            identifikatorUlozisko,
            verziaUlozisko,
            undefined,
            undefined,
            {
              responseType: 'blob',
            }
          )
          .then((response) => {
            FileDownload(response.data, response.headers.filename)
          })
        return
      }
      console.log('Downloading priloha from zhrnutie podana')
      await portalZoppmApi
        .fetchContentOfDokumentForZoppmPortalZoppm(
          ziadostId,
          identifikatorUlozisko,
          verziaUlozisko,
          undefined,
          undefined,
          {
            responseType: 'blob',
          }
        )
        .then((response) => {
          FileDownload(response.data, response.headers.filename)
        })
    } else {
      if (!kodIrz) {
        return
      }
      try {
        console.log('Downloading priloha from rozpracovana.')
        await zoppmDraftApi
          .fetchContentOfDokumentForZoppmDraftZoppmDraft(
            kodIrz,
            identifikatorUlozisko,
            verziaUlozisko,
            undefined,
            undefined,
            {
              responseType: 'blob',
            }
          )
          .then((response) => {
            FileDownload(response.data, response.headers.filename)
          })
      } catch {}
    }
  }

  return getDokument
}
